// import React, { useState } from "react";
// import ImageKit from "imagekit-javascript";

// const imagekit = new ImageKit({
//   publicKey: "YOUR_PUBLIC_KEY",
//   urlEndpoint: "https://ik.imagekit.io/YOUR_IMAGEKIT_ID",
//   authenticationEndpoint: "http://localhost:5000/auth", // backend endpoint
// });

// const ImageUpload = ({ onUploadSuccess }) => {
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [preview, setPreview] = useState(null);

//   // handle file selection
//   const handleChange = (e) => {
//     const selectedFile = e.target.files[0];

//     if (!selectedFile) return;

//     // basic validation
//     if (!selectedFile.type.startsWith("image/")) {
//       alert("Please select a valid image file");
//       return;
//     }

//     setFile(selectedFile);
//     setPreview(URL.createObjectURL(selectedFile));
//   };

//   // upload to ImageKit
//   const handleUpload = async () => {
//     if (!file) {
//       alert("Please select an image first");
//       return;
//     }

//     try {
//       setLoading(true);

//       const response = await imagekit.upload({
//         file: file,
//         fileName: file.name,
//       });

//       console.log("Upload Success:", response);

//       // return URL to parent
//       if (onUploadSuccess) {
//         onUploadSuccess(response.url, response.fileId);
//       }

//       alert("Image uploaded successfully");
//     } catch (error) {
//       console.error("Upload Error:", error);
//       alert("Upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={{ maxWidth: "400px" }}>
//       <input type="file" accept="image/*" onChange={handleChange} />

//       {preview && (
//         <div style={{ marginTop: "10px" }}>
//           <img
//             src={preview}
//             alt="preview"
//             style={{ width: "100%", borderRadius: "8px" }}
//           />
//         </div>
//       )}

//       <button
//         onClick={handleUpload}
//         disabled={loading}
//         style={{
//           marginTop: "10px",
//           padding: "10px",
//           width: "100%",
//           cursor: "pointer",
//         }}
//       >
//         {loading ? "Uploading..." : "Upload Image"}
//       </button>
//     </div>
//   );
// };

// export default ImageUpload;

// import React, { useState } from "react";
// import ImageKit from "imagekit-javascript";

// const imagekit = new ImageKit({
//   publicKey: "YOUR_PUBLIC_KEY",
//   urlEndpoint: "https://ik.imagekit.io/YOUR_IMAGEKIT_ID",
// });

// const ImageUpload = ({ onUploadSuccess }) => {
//   const [file, setFile] = useState(null);
//   const [preview, setPreview] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (!selectedFile) return;

//     if (!selectedFile.type.startsWith("image/")) {
//       alert("Please select a valid image");
//       return;
//     }

//     setFile(selectedFile);
//     setPreview(URL.createObjectURL(selectedFile));
//   };

//   const handleUpload = async () => {
//     if (!file) {
//       alert("Select image first");
//       return;
//     }

//     try {
//       setLoading(true);

//       // ⚠️ You must generate these manually (temporary)
//       const authRes = await fetch("http://localhost:5000/auth");
//       const { signature, token, expire } = await authRes.json();

//       const response = await imagekit.upload({
//         file: file,
//         fileName: file.name,
//         signature,
//         token,
//         expire,
//       });

//       console.log("Uploaded:", response);

//       if (onUploadSuccess) {
//         onUploadSuccess(response.url, response.fileId);
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="flex">
//       <input
//         type="file"
//         accept="image/*"
//         onChange={handleChange}
//         className="w-full text-sm text-gray-600
//                file:mr-4 file:py-2 file:px-4
//                file:rounded-md file:border-0
//                file:text-sm file:font-semibold
//                file:bg-blue-50 file:text-blue-700
//                hover:file:bg-blue-100 cursor-pointer"
//       />

//       {preview && (
//         <img
//           src={preview}
//           alt="preview"
//           className="mt-4 w-full h-48 object-cover rounded-md border"
//         />
//       )}

//       <button
//         onClick={handleUpload}
//         disabled={loading}
//         className={`mt-4 w-full py-2 rounded-md text-white font-medium transition
//       ${
//         loading
//           ? "bg-gray-400 cursor-not-allowed"
//           : "bg-blue-600 hover:bg-blue-700"
//       }`}
//       >
//         {loading ? "Uploading..." : "Upload"}
//       </button>
//     </div>
//   );
// };

// export default ImageUpload;

import React, { useRef, useState } from "react";
import ImageKit from "imagekit-javascript";
import { Image } from "lucide-react"; // icon

const imagekit = new ImageKit({
  publicKey: "public_h3lZj4ketvBHKpFpWtUKvZJLcL8=",
  urlEndpoint: "https://ik.imagekit.io/fjqto70c6",
});

const ImageUpload = ({ onUploadSuccess }) => {
  const fileInputRef = useRef(null);
  const [uploadingImage, setUploadingImage] = useState(false);

  // open file picker
  const handleClick = () => {
    fileInputRef.current.click();
  };

  // handle file selection + auto upload
  const handleChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Only image allowed");
      return;
    }

    try {
      setUploadingImage(true);

      // get auth (temporary backend)
      const authRes = await fetch("/api/auth");
      const { signature, token, expire } = await authRes.json();

      const response = await imagekit.upload({
        file,
        fileName: file.name,
        signature,
        token,
        expire,
      });

      console.log("Uploaded:", response);

      // return URL
      if (onUploadSuccess) {
        onUploadSuccess(response.url, response.fileId);
      }
    } catch (error) {
      console.error(error);
      alert("Upload failed");
    } finally {
      setUploadingImage(false);
    }
  };

  return (
    <>
      {/* hidden input */}
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleChange}
        className="hidden"
      />

      {/* single button */}
      <button
        type="button"
        onClick={handleClick}
        disabled={uploadingImage}
        className="border rounded-md p-2 hover:bg-gray-100 disabled:opacity-50"
      >
        {uploadingImage ? "..." : <Image className="h-4 w-4" />}
      </button>
    </>
  );
};

export default ImageUpload;
